import script from "./SuccessfulVerification.vue?vue&type=script&setup=true&lang=js"
export * from "./SuccessfulVerification.vue?vue&type=script&setup=true&lang=js"

import "./SuccessfulVerification.vue?vue&type=style&index=0&id=31568732&lang=css"

const __exports__ = script;

export default __exports__